import { InfoSet } from "../InfoSets/InfoSet";
import { ObjUtils, Iterable, IComparable } from "../Utils/ObjUtils";
import { Dictionary } from "../Utils/Dictionary";
import { Device } from "../Core/Device";

export class MonitorStatsEntry {

	public TimeStamp: Date;
	public get HasTimeStamp(): boolean {
		if (!this.TimeStamp)
			return false;
		if (this.TimeStamp.valueOf() <= 0)
			return false;
		return true;
	}

	public ErrorMessage: string;
	public get HasErrorMessage(): boolean {
		return !!this.ErrorMessage;
	}


	constructor(timeStamp?: Date) {
		this._Init();
		if (timeStamp)
			this.TimeStamp = timeStamp;
		else
			this.TimeStamp = new Date();
	}

	private _Init(): void {
		this.TimeStamp = new Date(0);
		this.ErrorMessage = '';
	}

	public CompareTo(obj: MonitorStatsEntry): number {
		if (obj == null)
			return 1;

		return ObjUtils.CompareTo(this.TimeStamp, obj.TimeStamp);
	}

	public Copy(otherObj:any): void {
		if (!otherObj || otherObj == this)
			return;

		if (otherObj.HasTimeStamp)
			this.TimeStamp = new Date(otherObj.TimeStamp.getTime());
		else
			this.TimeStamp = new Date(0);

		this.ErrorMessage = '';
		if (otherObj.HasErrorMessage)
			this.ErrorMessage = otherObj.ErrorMessage + '';
	}

	public Equals(obj: any): boolean {
		if (!obj == null)
			return false;

		if (this == obj)
			return true;

		if (!(obj instanceof MonitorStatsEntry))
			return false;

		var other = <MonitorStatsEntry> obj;

		return ObjUtils.Equals(this.TimeStamp, other.TimeStamp);
	}

	public GetHashCode(): number {
		return ObjUtils.GetHashCode(this.TimeStamp);
	}
}
	
export class MonitorStatsTable<K extends MonitorStatsEntry> extends InfoSet {

	private _statsList: Dictionary<Date, K>;
	private _typeConstructor: any;

	public GetTypeConstructor(): any {
		return MonitorStatsEntry;
	}
		
	constructor(device: Device, typeConstructor) {
		super(device);
		this._statsList = new Dictionary<Date, K>();
		this._typeConstructor = typeConstructor;
	}

	//private TrimToSize(limitCount:number):void	{
	//	while (this._statsList.Count > limitCount) {
	//		this.RemoveOldest();
	//	}
	//}

	protected CreateEntry(timeStamp:Date):K
	{
		var newEntry = new this._typeConstructor();
		newEntry.TimeStamp = timeStamp;
		return newEntry;
	}

	public Add(timeStamp: Date): K {
		if (timeStamp == null)
			return null;
		if (timeStamp.getTime() <= 0)
			return null;

		var newEntry = this.Find(timeStamp);
		if (!newEntry) {
			newEntry = this.CreateEntry(timeStamp);
			this._statsList.Add(timeStamp, newEntry);
		}

		return newEntry;
	}

	public AddEntry(statsEntry:K):boolean {
		if (statsEntry == null)
			return false;

		var newEntry: K = this._statsList.Item(statsEntry.TimeStamp);
		if(!newEntry) {
			this._statsList.Add(statsEntry.TimeStamp, statsEntry);
			newEntry = statsEntry;
		}
		else {
			newEntry.Copy(statsEntry);
		}
		return newEntry != null;
	}
		
	//public Append(appendTable: MonitorStatsTable<K>, maxStats:number): number {
	//	if ((appendTable == null) || (appendTable.Count <= 0))
	//		return 0;
	//	if (appendTable == this)
	//		return 0;

	//	var appendCount = 0;

	//	appendTable.ForEach((entry) => {
	//		var newEntry: K = this.Add(entry.TimeStamp);
	//		if (newEntry == null)
	//			return;
	//		newEntry.Copy(entry);

	//		appendCount++;
	//	});

	//	this.TrimToSize(maxStats);

	//	return appendCount;
	//}

	public Clear():void {
		if (this._statsList.Count > 0)
			this._statsList.Clear();
	}

	//public Copy(otherTable: MonitorStatsTable<K>) {
	//	this.Clear();

	//	if (otherTable == null)
	//		return;

	//	otherTable.ForEach((statsEntry) => {
	//		if (!statsEntry.HasTimeStamp)
	//			return;

	//		var newEntry:K = this.Add(statsEntry.TimeStamp);
	//		if (newEntry == null)
	//			return;

	//		newEntry.Copy(statsEntry);
	//	});
	//}

	public get Count(): number { 
		return this._statsList.Count;
	}

	public Contains(statsEntry:K):boolean
	{
		return this._statsList.Values().Contains(statsEntry);
	}

	public Find(timeStamp:Date): K {
		var statsEntry:K = null;

		if ((timeStamp != null) && (timeStamp.valueOf() > 0)) {
			statsEntry = this._statsList.Item(timeStamp);
		}

		return statsEntry;
	}

	//public GetLast_ErrorMessage(): string {
	//	var errorMessage = '';

	//	var statsEntry:K = this.GetLast();
	//	if ((statsEntry != null) && statsEntry.HasErrorMessage)
	//		errorMessage = statsEntry.ErrorMessage;

	//	return (errorMessage);
	//}

	//public GetLast():K {
	//	var statsEntry:K = null;

	//	if (this._statsList.Count > 0)
	//		statsEntry = this._statsList.Last().Value;

	//	return statsEntry;
	//}

	//public K[] GetLast(int lastCount = 1)
	//{
	//	if (lastCount <= 0)
	//		return null;
	//	if (this.Count <= 0)
	//		return null;
	//	if (this.Count < lastCount)
	//		return null;

	//	var lastArray = new K[lastCount];

	//	int listCount = _statsList.Count();
	//	int statCount = 0;

	//	for (int I = (listCount - lastCount); I < listCount; I++)
	//	{
	//		lastArray[statCount++] = _statsList.Values[I];
	//	}

	//	return lastArray;
	//}

	//public HashSet < DateTime > GetKeyTimestamps()
	//{
	//	HashSet < DateTime > timeStamps = new HashSet<DateTime>();

	//	foreach(KeyValuePair < DateTime, K > kvpEntry in _statsList)
	//	{
	//		timeStamps.Add(kvpEntry.Key);
	//	}

	//	return timeStamps;
	//}

	//public bool Remove(DateTime timeStamp)
	//{
	//	if (timeStamp == null)
	//		return false;
	//	if (timeStamp.Ticks <= 0)
	//		return false;

	//	return (_statsList.Remove(timeStamp));
	//}

	//public bool Remove(K statsEntry)
	//{
	//	if (statsEntry == null)
	//		return false;
	//	if (!statsEntry.HasTimeStamp)
	//		return false;

	//	return (_statsList.Remove(statsEntry.TimeStamp));
	//}

	//public bool RemoveOldest()
	//{
	//	if (_statsList.Count <= 0)
	//		return false;

	//	try
	//	{
	//		K firstEntry = _statsList.Values[0];
	//		if (firstEntry != null) {
	//			Remove(firstEntry);
	//			return true;
	//		}
	//	}
	//	catch
	//	{
	//	}
	//	return false;
	//}
}
